import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ViewCell } from '../ofbiz-form-model';
import { Cell } from 'angular2-smart-table';

@Component({
  template: `
    <div class="hyperlink" (click)="emit($event)">{{renderValue}}</div>
  `,
})
export class OfbizCellDisplayLinkComponent implements ViewCell, OnInit {

  renderValue: string;
  @Input() cell:Cell;
  @Input() value: string | number;
  @Input() rowData: any;
  @Output() cellHyperlinkSelected = new EventEmitter();
  constructor() { }

  ngOnInit(): void {
    console.log("OfbizCellDisplayLinkComponent ngOnInit called",this.cell.getValue());
    this.value = this.cell.getValue();
    this.rowData = this.cell.getRow().getData();
    this.renderValue = this.value.toString();
  }

  emit(e){
    console.log(e)
    console.log(this.value);
    console.log({TrackDisplayCellLink:this.rowData});
    this.cellHyperlinkSelected.emit(this.rowData);
  }

}
